import {useParams} from '@github-ui/react-router'
import {ReposIssuesSidebar as SharedRepoIssuesSidebar} from '@github-ui/repos-issues-sidebar/ReposIssuesSidebar'

export function RepoIssuesSidebar() {
  const {owner, repo} = useParams<{owner: string; repo: string}>()
  return <SharedRepoIssuesSidebar owner={owner ?? ''} repo={repo ?? ''} />
}
